<template>
    <section class="register" ref="toppage" v-bind:class="{ 'register--loading': $store.state.loading }">
        <DVCARegisterLoader />
        <DVCARegisterErrors />

        <h1>Registration</h1>

        <ul class="register__progress">
            <li class="register__progress-step" v-bind:class="{'active': $store.state.step == 'about'}">
                <i class="fal fa-circle" aria-hidden="true"></i>
                <span>About You</span>
            </li>
            <li class="register__progress-step" v-bind:class="{'active': $store.state.step == 'interests'}">
                <i class="fal fa-circle" aria-hidden="true"></i>
                <span>Interests</span>
            </li>
            <li class="register__progress-step" v-bind:class="{'active': $store.state.step == 'membership'}">
                <i class="fal fa-circle" aria-hidden="true"></i>
                <span>Membership</span>
            </li>
            <li class="register__progress-step" v-bind:class="{'active': $store.state.step == 'payment'}">
                <i class="fal fa-circle" aria-hidden="true"></i>
                <span>Payment</span>
            </li>
            <li class="register__progress-step" v-bind:class="{'active': $store.state.step == 'complete'}">
                <i class="fal fa-circle" aria-hidden="true"></i>
                <span>Complete!</span>
            </li>
        </ul>

        <div class="register__steps">
            <DVCARegisterAbout />
            <DVCARegisterInterests />
            <DVCARegisterMembership />
            <DVCARegisterPayment />
            <DVCARegisterComplete />
        </div>

        <template v-if="$store.state.promocode!=null">
            <div class="alert alert-warning">
                <span v-html="'Promotional code was applied: ' + $store.state.promocode"></span>
            </div>
        </template>
    </section>
</template>

<script>
import DVCARegisterLoader from "@/components/DVCARegisterLoader.vue";
import DVCARegisterErrors from "@/components/DVCARegisterErrors";
import DVCARegisterAbout from "@/components/DVCARegisterAbout.vue";
import DVCARegisterInterests from "@/components/DVCARegisterInterests.vue";
import DVCARegisterMembership from "@/components/DVCARegisterMembership.vue";
import DVCARegisterComplete from "@/components/DVCARegisterComplete.vue";
import DVCARegisterPayment from "@/components/DVCARegisterPayment.vue";


export default {
    name: "Home",
    components: {
        DVCARegisterLoader,
        DVCARegisterErrors,
        DVCARegisterAbout,
        DVCARegisterInterests,
        DVCARegisterMembership,
        DVCARegisterComplete,
        DVCARegisterPayment
    },
    
    methods: {
        goto(refName) {
            var element = this.$refs[refName];
            var top = element.offsetTop;
            
            window.scrollTo({
                top: top,
                behavior: 'smooth',
            });
        },
        gotop() {
           this.goto("toppage");
        }
    },
    mounted: function() {
        this.$store.dispatch( 'fetch_plans' );
    }
};
</script>
